<div class="attachments-dialog">
  <div class="dialog-header">
    <h2>Attachments</h2>
    @if (data.contextLabel) {
      <p class="context-label">{{ data.contextLabel }}</p>
    }
  </div>

  <div class="dialog-content">
    <!-- Dropzone for upload (only if canEdit) -->
    @if (data.canEdit) {
      <div class="upload-section">
        <app-file-upload-dropzone
          [disabled]="isUploading"
          (filesSelected)="onFilesSelected($event)"
          (validationError)="onValidationError($event)">
        </app-file-upload-dropzone>
        @if (isUploading) {
          <mat-progress-bar mode="indeterminate" class="upload-progress"></mat-progress-bar>
        }
      </div>
    }

    <!-- Loading spinner -->
    @if (isLoading) {
      <div class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
        <span>Loading attachments...</span>
      </div>
    }

    <!-- Attachments table -->
    @if (!isLoading) {
      <div class="table-container">
        <app-data-table
          [columns]="columns"
          [data]="attachments"
          [loading]="isLoading"
          [emptyMessage]="'No attachments yet'"
          [alternateRowColors]="true">
          <ng-template #cellTemplate let-row let-column="column" let-value="value">
            @switch (column.key) {
              <!-- File Name with icon -->
              @case ('fileName') {
                <div class="file-name-cell">
                  <span class="file-badge" [style.background-color]="getFileIconColor(row.contentType)">
                    {{ getFileExtension(row.fileName) }}
                  </span>
                  <span class="file-name-text">{{ value }}</span>
                </div>
              }
              <!-- Actions -->
              @case ('actions') {
                <div class="actions-cell">
                  <button mat-icon-button
                    [style.visibility]="canPreview(row.contentType) ? 'visible' : 'hidden'"
                    (click)="$event.stopPropagation(); viewAttachment(row)"
                    matTooltip="View">
                    <mat-icon>visibility</mat-icon>
                  </button>
                  <button mat-icon-button
                    (click)="$event.stopPropagation(); downloadAttachment(row)"
                    matTooltip="Download">
                    <mat-icon>download</mat-icon>
                  </button>
                  @if (data.canEdit) {
                    <button mat-icon-button
                      class="delete-btn"
                      (click)="$event.stopPropagation(); deleteAttachment(row)"
                      matTooltip="Delete">
                      <mat-icon>delete</mat-icon>
                    </button>
                  }
                </div>
              }
              <!-- Date -->
              @case ('createdAtUtc') {
                {{ formatDate(value) }}
              }
              <!-- Default -->
              @default {
                {{ value }}
              }
            }
          </ng-template>
        </app-data-table>
      </div>
    }

  </div>

  <div class="dialog-footer">
    <button (click)="close()">
      <mat-icon>arrow_back</mat-icon>
      Back
    </button>
  </div>
</div>
